import { fetchPageAssets } from '../../ducks/hostedAssets.duck';
// FairwayBid: eigene Anzeigen fuer den Dashboard-Abschnitt der Startseite.
// Wir nutzen bewusst den bestehenden Duck der Seite "Anzeigen verwalten" –
// gleiche Datenquelle, kein zweiter Zustand, der auseinanderlaufen kann.
import { queryOwnListings } from '../ManageListingsPage/ManageListingsPage.duck';
// Und die eingegangenen Angebote: Aus Sicht des Clubs sind das seine "orders",
// denn die Anfrage gehoert ihm und der Haendler eroeffnet die Transaktion.
import { loadDataThunk as loadInboxData } from '../InboxPage/InboxPage.duck';
import { getAudience, DEALER } from '../../fairwaybid/audience';
// Und die Anfragen, die zu den Kategorien und Liefergebieten des Haendlers passen.
import { buildMatchQuery } from '../../fairwaybid/matching';
import { BUNDLE_OPEN_VALUES } from '../../fairwaybid/bundles';
import { searchListings } from '../SearchPage/SearchPage.duck';
import { hasPermissionToViewData, isUserAuthorized } from '../../util/userHelpers';

export const ASSET_NAME = 'landing-page';

export const loadData = (params, search, config) => (dispatch, getState) => {
  const pageAsset = { landingPage: `content/pages/${ASSET_NAME}.json` };
  const assets = dispatch(fetchPageAssets(pageAsset, true));

  // Nur fuer angemeldete Nutzer, und ein Fehler hier darf die Startseite
  // niemals blockieren – ohne eigene Anzeigen zeigt das Dashboard einfach nichts.
  const isAuthenticated = getState()?.auth?.isAuthenticated;
  const own = isAuthenticated
    ? dispatch(
        queryOwnListings({
          page: 1,
          // Das Dashboard zeigt die eigenen Anfragen ohne Blaetterung. Bei zehn
          // endete die Liste stillschweigend - und mit ihr der Bündel-Kasten,
          // der sich aus derselben Quelle speist.
          perPage: 50,
          include: ['images'],
          'limit.images': 1,
        })
      ).catch(() => null)
    : Promise.resolve(null);

  // Die Angebote kommen aus demselben Duck wie der Posteingang, damit es keinen
  // zweiten Zustand gibt, der auseinanderlaufen kann. Auch hier gilt: ein Fehler
  // darf die Startseite nicht blockieren.
  // Clubs sehen die eingegangenen Angebote ("orders"), Haendler ihre eigenen
  // abgegebenen Angebote ("sales") – daraus ergibt sich ihr Monatskontingent.
  const currentUser = getState()?.user?.currentUser;
  const audience = getAudience(currentUser);
  const tab = audience === DEALER ? 'sales' : 'orders';
  const offers = isAuthenticated
    ? dispatch(loadInboxData({ params: { tab }, search: '' })).catch(() => null)
    : Promise.resolve(null);

  // Beide Seiten laden zusaetzlich fremde Anfragen, aber aus verschiedenen
  // Gruenden: Haendler die passenden aus ihren Kategorien, Golfanlagen die
  // gleichartigen offenen fuer die Buendelausschreibung. Beides landet im
  // Such-Duck, weil dort ohnehin genau diese Abfrage lebt.
  // Konten in Pruefung duerfen keine Anzeigen sehen; die Abfrage waere ein
  // sicherer 403. Das Dashboard erklaert diesen Zustand stattdessen im Text.
  const mayViewListings = isUserAuthorized(currentUser) && hasPermissionToViewData(currentUser);
  const matchQuery = audience === DEALER && mayViewListings ? buildMatchQuery(currentUser) : null;
  const matching = matchQuery
    ? dispatch(
        searchListings({
          searchParams: {
            ...matchQuery,
            perPage: 12,
            include: ['author', 'images'],
            'fields.listing': ['title', 'publicData', 'state', 'publishedAt', 'createdAt'],
            'limit.images': 1,
          },
          config,
        })
      ).catch(() => null)
    : Promise.resolve(null);

  // Golfanlagen: der Buendel-Pool. Alle offenen Anfragen anderer Anlagen, die
  // fuer eine gemeinsame Bestellung offen sind.
  //
  // Bewusst NICHT auf die eigenen Kategorien eingeschraenkt und nicht davon
  // abhaengig, dass die Anlage ueberhaupt schon eine Anfrage hat: Der Sinn des
  // Pools ist, sich an etwas anzuhaengen, das man selbst noch nicht
  // ausgeschrieben hat. Wer erst filtert, was er schon sucht, findet nie etwas
  // Neues.
  const bundles =
    audience === DEALER || !mayViewListings
      ? Promise.resolve(null)
      : dispatch(
          searchListings({
            searchParams: {
              pub_bundle_allowed: BUNDLE_OPEN_VALUES.join(','),
              perPage: 24,
              include: ['author'],
              'fields.listing': ['title', 'publicData', 'state', 'publishedAt', 'createdAt'],
            },
            config,
          })
        ).catch(() => null);

  return Promise.all([assets, own, offers, matching, bundles]);
};
